import { render, staticRenderFns } from "./CourseImport.vue?vue&type=template&id=c76518f8"
import script from "./CourseImport.vue?vue&type=script&lang=js"
export * from "./CourseImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports